import { BigNumber, ethers } from "ethers";

export const convertBigNumber = (value: BigNumber, decimals: number = 8) => {
  return Number(ethers.utils.formatUnits(value, decimals));
};
